"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormReader = exports.FormWriter = void 0;
var writer_1 = require("./writer");
Object.defineProperty(exports, "FormWriter", { enumerable: true, get: function () { return __importDefault(writer_1).default; } });
var reader_1 = require("./reader");
Object.defineProperty(exports, "FormReader", { enumerable: true, get: function () { return __importDefault(reader_1).default; } });
//# sourceMappingURL=index.js.map